/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Filters_Inprogress1Inputs */

const id_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang Berlangsung`)
};

const ms_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang Berjalan`)
};

const da_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I Gang`)
};

const de_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bearbeitung`)
};

const en_us2_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const es_es2_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En progreso`)
};

const es_mx2_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En progreso`)
};

const fil_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyan`)
};

const fr_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const it_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In corso`)
};

const hu_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folyamatban`)
};

const nl_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig`)
};

const no_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pågår`)
};

const pl_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W trakcie`)
};

const pt_br2_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento`)
};

const pt_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em progresso`)
};

const ro_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În progres`)
};

const fi_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesken`)
};

const sv_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pågående`)
};

const vi_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tiến hành`)
};

const tr_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam Eden`)
};

const cs_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpracované`)
};

const bg_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В прогрес`)
};

const ru_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В процессе`)
};

const uk_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У процесі`)
};

const ar_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قيد التقدم`)
};

const hi_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति पर`)
};

const th_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังดำเนินการ`)
};

const ja_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中`)
};

const zh_cn2_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中`)
};

const zh_hant1_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中`)
};

const ko_profile_library_filters_inprogress1 = /** @type {(inputs: Profile_Library_Filters_Inprogress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 중`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Profile_Library_Filters_Inprogress1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_filters_inprogress1 = /** @type {((inputs?: Profile_Library_Filters_Inprogress1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Filters_Inprogress1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_filters_inprogress1(inputs)
	if (locale === "ms") return ms_profile_library_filters_inprogress1(inputs)
	if (locale === "da") return da_profile_library_filters_inprogress1(inputs)
	if (locale === "de") return de_profile_library_filters_inprogress1(inputs)
	if (locale === "en-US") return en_us2_profile_library_filters_inprogress1(inputs)
	if (locale === "es-ES") return es_es2_profile_library_filters_inprogress1(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_filters_inprogress1(inputs)
	if (locale === "fil") return fil_profile_library_filters_inprogress1(inputs)
	if (locale === "fr") return fr_profile_library_filters_inprogress1(inputs)
	if (locale === "it") return it_profile_library_filters_inprogress1(inputs)
	if (locale === "hu") return hu_profile_library_filters_inprogress1(inputs)
	if (locale === "nl") return nl_profile_library_filters_inprogress1(inputs)
	if (locale === "no") return no_profile_library_filters_inprogress1(inputs)
	if (locale === "pl") return pl_profile_library_filters_inprogress1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_filters_inprogress1(inputs)
	if (locale === "pt") return pt_profile_library_filters_inprogress1(inputs)
	if (locale === "ro") return ro_profile_library_filters_inprogress1(inputs)
	if (locale === "fi") return fi_profile_library_filters_inprogress1(inputs)
	if (locale === "sv") return sv_profile_library_filters_inprogress1(inputs)
	if (locale === "vi") return vi_profile_library_filters_inprogress1(inputs)
	if (locale === "tr") return tr_profile_library_filters_inprogress1(inputs)
	if (locale === "cs") return cs_profile_library_filters_inprogress1(inputs)
	if (locale === "bg") return bg_profile_library_filters_inprogress1(inputs)
	if (locale === "ru") return ru_profile_library_filters_inprogress1(inputs)
	if (locale === "uk") return uk_profile_library_filters_inprogress1(inputs)
	if (locale === "ar") return ar_profile_library_filters_inprogress1(inputs)
	if (locale === "hi") return hi_profile_library_filters_inprogress1(inputs)
	if (locale === "th") return th_profile_library_filters_inprogress1(inputs)
	if (locale === "ja") return ja_profile_library_filters_inprogress1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_filters_inprogress1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_filters_inprogress1(inputs)
	return ko_profile_library_filters_inprogress1(inputs)
});
export { profile_library_filters_inprogress1 as "profile.library.filters.inProgress" }